/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GrowthAllocationType = {
    US_DIRECT_STOCKS: 'us_direct_stocks',
    US_EQUITY_ETF: 'us_equity_etf',
    DEVELOPED_EQUITY_ETF: 'developed_equity_etf',
    EMERGING_EQUITY_ETF: 'emerging_equity_etf',
    CASH_EQUIVALENTS: 'cash_equivalents',
    SHORT_TERM_TREASURIES_3M: 'short_term_treasuries_3m',
    SHORT_TERM_TREASURIES_1Y: 'short_term_treasuries_1y',
    BOND_LADDER_2Y: 'bond_ladder_2y',
    BOND_LADDER_5Y: 'bond_ladder_5y',
    BOND_LADDER_7Y: 'bond_ladder_7y',
    BOND_LADDER_10Y: 'bond_ladder_10y',
    BOND_LADDER_20Y: 'bond_ladder_20y',
    BOND_LADDER_30Y: 'bond_ladder_30y',
    LEVERED_BOND_ETF: 'levered_bond_etf',
    ENHANCED_TREASURIES: 'enhanced_treasuries',
    HEDGED_EQUITY: 'hedged_equity',
    CUSTOM_ASSET: 'custom_asset',
    NON_CONFORMING: 'non_conforming',
    CLIENT_DIRECTED: 'client_directed',
    EXTERNALLY_MANAGED: 'externally_managed'
} as const;
export type GrowthAllocationType = typeof GrowthAllocationType[keyof typeof GrowthAllocationType];


export function instanceOfGrowthAllocationType(value: any): boolean {
    for (const key in GrowthAllocationType) {
        if (Object.prototype.hasOwnProperty.call(GrowthAllocationType, key)) {
            if (GrowthAllocationType[key as keyof typeof GrowthAllocationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GrowthAllocationTypeFromJSON(json: any): GrowthAllocationType {
    return GrowthAllocationTypeFromJSONTyped(json, false);
}

export function GrowthAllocationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrowthAllocationType {
    return json as GrowthAllocationType;
}

export function GrowthAllocationTypeToJSON(value?: GrowthAllocationType | null): any {
    return value as any;
}

export function GrowthAllocationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): GrowthAllocationType {
    return value as GrowthAllocationType;
}

